import { render, staticRenderFns } from "./addBoardModal.vue?vue&type=template&id=c644a3b6&scoped=true&"
import script from "./addBoardModal.vue?vue&type=script&lang=js&"
export * from "./addBoardModal.vue?vue&type=script&lang=js&"
import style0 from "./addBoardModal.vue?vue&type=style&index=0&id=c644a3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c644a3b6",
  null
  
)

export default component.exports